(function ($, undefined) {
    'use strict';

    var formValidator;
    var utils;

    // NOTE: emails array is only for popup chip UI (if you still use it)
    let emails = [];

    let url = "";
    const domain = window.location.hostname;
    if (domain === "localhost") url = `http://localhost:9101`;
    else url = `/analyticservice`;

    let currentUserEmail = ""; // kept (not required anymore), harmless
    let currentRowKey = "";    // ✅ NEW: active row key for checklist modal
    let geofenceUrl = "";
    if (domain === "localhost") geofenceUrl = `http://localhost:9105`;
    else geofenceUrl = `/geofence-service`;

    var savedData = {}; // { [locationId]: [ { rowKey, email, ...settings } ] }
    let SAMPLE_CL = [];

    const applyBtn = document.getElementById("applyToOtherLocationsBtn");
    const locationPopup = document.getElementById("locationPopup");
    const locationCheckboxes = document.getElementById("locationCheckboxes");

    // These exist in your DOM (as per your original code)
    const cancelLocationBtn = document.getElementById("cancelLocationBtn");
    const confirmLocationBtn = document.getElementById("confirmLocationBtn");
    const notifLocationSelect = document.getElementById("notifLocationSelect");

    let checklistColumnAdded = false;

    var table; // DataTable instance

    // ============================================================
    // ✅ ROW KEY HELPERS (CRITICAL FOR DUPLICATE EMAIL SETTINGS)
    // ============================================================
    function makeRowKey() {
        return 'rk_' + Date.now() + '_' + Math.random().toString(16).slice(2);
    }

    function deepClone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    function ensureRowKey(row) {
        if (row && row.rowKey) return row.rowKey;

        // If server row has personId, use stable key (best)
        if (row && row.personId != null) return 'pid_' + row.personId;

        // For server rows with no personId (rare), fallback:
        // this is NOT unique if duplicates exist, but used only if unavoidable
        if (row && row.email) return 'email_' + row.email;

        return makeRowKey();
    }

    function getLocationId() {
        return $('#notifLocationSelect').val();
    }

    function getSavedRowsForLocation(locationId) {
        if (!savedData[locationId]) savedData[locationId] = [];
        return savedData[locationId];
    }

    function findSavedRow(locationId, rowKey) {
        return (savedData[locationId] || []).find(r => r.rowKey === rowKey) || null;
    }

    function upsertSavedRow(locationId, rowObj) {
        if (!savedData[locationId]) savedData[locationId] = [];
        savedData[locationId] = savedData[locationId].filter(r => r.rowKey !== rowObj.rowKey);
        savedData[locationId].push(rowObj);
    }

    function removeSavedRow(locationId, rowKey) {
        if (!savedData[locationId]) return;
        savedData[locationId] = savedData[locationId].filter(r => r.rowKey !== rowKey);
    }

    // ============================================================
    // INIT
    // ============================================================
    var init = function () {
        formValidator = (window.Fw && Fw.component && Fw.component.models) ? Fw.component.models().form : null;
        utils = (window.Fw && Fw.component && Fw.component.models) ? Fw.component.models().utils : null;

        if (window.location.pathname == '/report-settings') {
            $("#checklistsModal").removeClass("show");

            // -------------------------------
            // SAVE CHECKLISTS (modal)
            // -------------------------------
            $("#checklistsModal .btn_primary").on("click", function () {

                const selectedIds = Array.from(window.currentTreeSelected || []);
                const locationId = $("#notifLocationSelect").val();

                // Find who opened the modal
                const $activeField = $(".cl-field.active-source");
                if (!$activeField.length) return;

                const source = $activeField.data("source");

                // -------------------------------------------
                // CASE 1 — GENERATE REPORT FIELD
                // -------------------------------------------
                if (source === "generate-report") {
                    $activeField.find('input[name="checklists-text-generate"]').val(
                        selectedIds.length ? `(${selectedIds.length}) Selected` : "Select Checklists"
                    );
                    $activeField.attr("data-items", selectedIds.join(","));
                    return;
                }

                // -------------------------------------------
                // CASE 2 — TABLE ROW CHECKLIST FIELD
                // ✅ MUST USE rowKey (NOT email)
                // -------------------------------------------
                if (source === "table") {
                    const rk = $activeField.data("rowkey");
                    const email = $activeField.data("email");

                    if (!rk) {
                        console.warn("Missing rowKey on active checklist field. Cannot save checklists safely.");
                        return;
                    }

                    if (!savedData[locationId]) savedData[locationId] = [];

                    let rowEntry = savedData[locationId].find(r => r.rowKey === rk);

                    // If no entry → create from DataTable row (best effort)
                    if (!rowEntry) {
                        const dt = $("#notifTable").DataTable();
                        const dtRow = dt.rows().data().toArray().find(r => r.rowKey === rk) || {};

                        rowEntry = {
                            rowKey: rk,
                            email: email,
                            personId: dtRow.personId || null,
                            reportType: dtRow.reportType || [],
                            frequency: dtRow.frequency || [],
                            shift: dtRow.shift || false,
                            incident: dtRow.incident || false,
                            patrol: dtRow.patrol || false,
                            checklists: []
                        };
                        savedData[locationId].push(rowEntry);
                    }

                    // Save checklist ids
                    rowEntry.checklists = selectedIds;

                    // Update visible count in table cell
                    $activeField.find('input[name="checklists-text"]').val(
                        selectedIds.length ? `(${selectedIds.length}) Selected` : "Select Checklists"
                    );
                }
            });

            // location select change
            $('#notifLocationSelect').off('change.notif').on('change.notif', actionLocationChange);
            $(document).on('click', '#notifSubmitBtn', nofitSubmit);

            // Get locations and then table
            getLocations();
            loadEmailPopup();
            pillTextForReport();

            // ---------- Prevent checkbox clicks from triggering DataTable sorting ----------
            ['mousedown', 'click', 'pointerdown'].forEach(evt => {
                document.addEventListener(evt, function (e) {
                    try {
                        if (e.target && e.target.closest && e.target.closest('input[type="checkbox"]')) {
                            e.stopPropagation();
                        }
                    } catch (err) { }
                }, true);
            });

            // Open popup
            document.getElementById("generateReportBtn").addEventListener("click", function () {
                document.getElementById("generateReportPopup").style.display = "flex";
            });

            // Close popup
            document.getElementById("cancelGenerateReportBtn").addEventListener("click", function () {
                document.getElementById("generateReportPopup").style.display = "none";
            });

            $('#confirmGenerateReportBtn').on('click', function () {
                const $btn = $('#confirmGenerateReportBtn');

                // Inject spinner CSS one time
                if (!document.getElementById("generate-btn-spinner-style")) {
                    const style = document.createElement("style");
                    style.id = "generate-btn-spinner-style";
                    style.innerHTML = `
            .btn-spinner {
              border: 2px solid #fff;
              border-top: 2px solid #3498db;
              border-radius: 50%;
              width: 14px;
              height: 14px;
              margin-right: 6px;
              display: inline-block;
              animation: spinBtn 0.8s linear infinite;
              vertical-align: middle;
            }
            @keyframes spinBtn {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `;
                    document.head.appendChild(style);
                }

                const originalHtml = $btn.html();
                $btn.prop("disabled", true);
                $btn.html(`<span class="btn-spinner"></span> Generating...`);

                var selectedReports = $('#reportFor .option.selected')
                    .map(function () { return $(this).data('value'); })
                    .get();

                if (selectedReports.length === 0) {
                    alert("Please select at least one report type.");
                    resetButton();
                    return;
                }

                var selectedChecklists = $('.cl-field[data-source="generate-report"]').attr('data-items') || "";

                var basePayload = {
                    reportType: $('#reportType').val(),
                    frequency: $('#frequency').val(),
                    locationId: $('#notifLocationSelect').val()
                };

                let completed = 0;
                let total = selectedReports.length;

                $.each(selectedReports, function (index, rpt) {
                    var payload = $.extend({}, basePayload, {
                        report: rpt,
                        checklists: selectedChecklists
                    });

                    $.ajax({
                        url: '/action/on-demand-report',
                        type: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify(payload),
                        xhrFields: { responseType: 'blob' },

                        success: function (blob) {
                            var url = window.URL.createObjectURL(blob);
                            var a = $('<a />', {
                                href: url,
                                download: getFileName(
                                    rpt,
                                    basePayload.frequency,
                                    basePayload.reportType,
                                    $('#notifLocationSelect option:selected').text() || 'Location'
                                )
                            }).appendTo('body');

                            a[0].click();
                            a.remove();
                            window.URL.revokeObjectURL(url);
                        },

                        error: function () {
                            console.error('Failed to generate ' + rpt + ' PDF');
                            alert('Failed to generate ' + rpt + ' PDF');
                        },

                        complete: function () {
                            completed++;
                            if (completed === total) resetButton();
                        }
                    });
                });

                function resetButton() {
                    $btn.prop("disabled", false);
                    $btn.html(originalHtml);
                }
            });

            $(document).off('.notif');

            // Toggle a single multiselect (delegated)
            $(document).on('click.notif', '.notif-multiselect', function (e) {
                e.stopPropagation();
                const $this = $(this);
                $('.notif-multiselect.open').not($this).removeClass('open');
                $this.toggleClass('open');
            });

            // ============================================================
            // ✅ Checklist field click (MUST STORE rowKey)
            // ============================================================
            $(document).on("click", ".cl-field", function () {
                const $field = $(this);
                const source = $field.data("source");
                let preselected = [];

                if (source === "table") {
                    currentUserEmail = $field.data("email") || "";
                    currentRowKey = $field.data("rowkey") || "";

                    const locationId = $("#notifLocationSelect").val();
                    const entry = currentRowKey ? (savedData[locationId] || []).find(r => r.rowKey === currentRowKey) : null;

                    if (entry && entry.checklists) preselected = [...entry.checklists];
                }

                if (source === "generate-report") {
                    const stored = $field.attr("data-items");
                    preselected = stored ? stored.split(",").map(Number) : [];
                }

                initTreeMultiSelect({
                    modalId: "checklistsModal",
                    data: SAMPLE_CL,
                    preselected: preselected,
                    onChange: function (selectedIds) {
                        window.currentTreeSelected = new Set(selectedIds);
                    }
                });

                $(".cl-field").removeClass("active-source");
                $(this).addClass("active-source");
                $("#checklistsModal").addClass("show");
            });

            // ============================================================
            // ✅ Multiselect option click → update savedData by rowKey
            // ============================================================
            $(document).on('click.notif', '.notif-multiselect .option', function (e) {
                e.stopPropagation();

                const $opt = $(this);
                const $ms = $opt.closest('.notif-multiselect');
                const $row = $ms.closest('tr');
                const rowData = table.row($row).data() || {};
                const locationId = $('#notifLocationSelect').val();

                const reportLabels = { summary: "Summary", fullReport: "Full Report" };
                const freqLabels = {
                    daily: "Daily", weekly: "Weekly", biweekly: "Bi-Weekly",
                    monthly: "Monthly", quarterly: "Quarterly", yearly: "Yearly"
                };

                let selected = $ms.data('selected') || [];
                const val = $opt.data('value');

                if (selected.includes(val)) selected = selected.filter(v => v !== val);
                else selected.push(val);

                $ms.data('selected', selected);

                let selectedLabels;
                if ($ms.hasClass('report-select')) selectedLabels = selected.map(v => reportLabels[v] || v);
                else if ($ms.hasClass('frequency-select')) selectedLabels = selected.map(v => freqLabels[v] || v);
                else selectedLabels = selected;

                $ms.find('.pill-text').text(selectedLabels.length ? selectedLabels.join(', ') : 'Select...');

                $ms.find('.option').each(function () {
                    const $o = $(this);
                    $o.toggleClass('selected', selected.includes($o.data('value')));
                });

                const rk = rowData.rowKey;
                if (!rk) {
                    console.warn("Row missing rowKey; cannot save multiselect safely.");
                    return;
                }

                if (!savedData[locationId]) savedData[locationId] = [];
                const existing = (savedData[locationId] || []).find(r => r.rowKey === rk);

                // rebuild updated row using rowKey identity
                const updatedRow = {
                    rowKey: rk,
                    email: rowData.email,
                    personId: rowData.personId,
                    reportType: $row.find('.report-select .option.selected')
                        .map((i, el) => $(el).data('value')).get(),
                    frequency: $row.find('.frequency-select .option.selected')
                        .map((i, el) => $(el).data('value')).get(),
                    shift: $row.find('input.shift').is(':checked'),
                    incident: $row.find('input.incident').is(':checked'),
                    patrol: $row.find('input.patrol').is(':checked')
                };

                // Preserve checklists if present
                if (existing && Array.isArray(existing.checklists)) {
                    updatedRow.checklists = [...existing.checklists];
                } else {
                    updatedRow.checklists = [];
                }

                upsertSavedRow(locationId, updatedRow);
            });

            // Close open dropdowns if clicking outside
            $(document).on('click.notif', function (e) {
                $('.notif-multiselect.open').each(function () {
                    if (!$(this).has(e.target).length) $(this).removeClass('open');
                });
            });

            // ---------- Select-all header checkboxes ----------
            $(document).on('change.notif', '#selectAllShift', function () {
                const checked = $(this).is(':checked');
                $('#notifTable').find('input.shift').prop('checked', checked).trigger('change');
            });

            $(document).on('change.notif', '#selectAllIncident', function () {
                const checked = $(this).is(':checked');
                $('#notifTable').find('input.incident').prop('checked', checked).trigger('change');
            });

            $(document).on('change.notif', '#selectAllPatrol', function () {
                const checked = $(this).is(':checked');
                $('#notifTable').find('input.patrol').prop('checked', checked).trigger('change');
            });

            // Header checkbox state updates
            $(document).on('change.notif', '#notifTable input.shift', function () {
                updateHeaderCheckboxState('shift', 'selectAllShift');
            });
            $(document).on('change.notif', '#notifTable input.incident', function () {
                updateHeaderCheckboxState('incident', 'selectAllIncident');
            });
            $(document).on('change.notif', '#notifTable input.patrol', function () {
                updateHeaderCheckboxState('patrol', 'selectAllPatrol');
            });

            // ============================================================
            // ✅ Row-level checkbox changes → update savedData by rowKey
            // ============================================================
            $(document).on('change.notif', '#notifTable input.shift, #notifTable input.incident, #notifTable input.patrol', function () {
                const $checkbox = $(this);
                const $row = $checkbox.closest('tr');
                const rowData = table.row($row).data() || {};
                const locationId = $('#notifLocationSelect').val();

                if (!savedData[locationId]) savedData[locationId] = [];
                const rk = rowData.rowKey;

                if (!rk) {
                    console.warn("Row missing rowKey; cannot save checkbox safely.");
                    return;
                }

                const existing = (savedData[locationId] || []).find(r => r.rowKey === rk);

                const updatedRow = {
                    rowKey: rk,
                    email: rowData.email,
                    personId: rowData.personId,
                    reportType: $row.find('.report-select .option.selected')
                        .map((i, el) => $(el).data('value')).get(),
                    frequency: $row.find('.frequency-select .option.selected')
                        .map((i, el) => $(el).data('value')).get(),
                    shift: $row.find('input.shift').is(':checked'),
                    incident: $row.find('input.incident').is(':checked'),
                    patrol: $row.find('input.patrol').is(':checked')
                };

                if (existing && Array.isArray(existing.checklists)) {
                    updatedRow.checklists = [...existing.checklists];
                } else {
                    updatedRow.checklists = [];
                }

                upsertSavedRow(locationId, updatedRow);

                console.log("✅ savedData updated (checkbox):", savedData);
            });

            popupConfig();
        }
    };

    // ============================================================
    // Apply settings to other locations (UPDATED for rowKey + duplicates)
    // ============================================================
    function popupConfig() {
        if (applyBtn) {
            applyBtn.addEventListener("click", () => {
                const currentLoc = notifLocationSelect.value;
                locationCheckboxes.innerHTML = "";

                [...notifLocationSelect.options].forEach(opt => {
                    if (opt.value !== currentLoc) {
                        const checkbox = `
              <label>
                <input type="checkbox" value="${opt.value}">
                ${opt.text}
              </label><br>`;
                        locationCheckboxes.insertAdjacentHTML("beforeend", checkbox);
                    }
                });

                locationPopup.style.display = "flex";
            });
        }

        if (cancelLocationBtn) {
            cancelLocationBtn.addEventListener("click", () => {
                locationPopup.style.display = "none";
            });
        }

        if (confirmLocationBtn) {
            confirmLocationBtn.addEventListener("click", () => {
                const sourceLocationId = notifLocationSelect.value;
                const targetLocationIds = [...locationCheckboxes.querySelectorAll("input:checked")].map(cb => cb.value);

                if (targetLocationIds.length === 0) {
                    showAlert("⚠️ Please select at least one target location.");
                    return;
                }

                const payload = { sourceLocationId, targetLocationIds };
                console.log("Final JSON:", payload);

                fetch("/action/compare-emails", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                })
                    .then(res => res.json())
                    .then(function (response) {

                        // ✅ Apply settings (duplicates supported):
                        // For each emailExists, copy ALL rows from source location with that email.
                        function applySettings() {
                            const sourceSettings = savedData[sourceLocationId] || [];

                            for (var loc in response) {
                                if (!response.hasOwnProperty(loc)) continue;
                                var data = response[loc];

                                if (!savedData[loc]) savedData[loc] = [];

                                (data.emailExists || []).forEach(function (email) {
                                    // find ALL settings in source for this email (could be multiple)
                                    const matches = sourceSettings.filter(s => s.email === email);

                                    // Remove all existing rows in target for that email
                                    savedData[loc] = savedData[loc].filter(r => r.email !== email);

                                    // Copy each match as separate row with NEW rowKey
                                    matches.forEach(function (setting) {
                                        const clone = deepClone(setting);
                                        clone.rowKey = makeRowKey(); // ✅ new identity per target row
                                        clone.locationId = loc;
                                        savedData[loc].push(clone);
                                    });
                                });
                            }

                            console.log("✅ Updated savedData (applySettings):", savedData);
                        }

                        // If missing emails exist -> show modal selection (your existing logic)
                        if (Object.keys(response).some(function (loc) {
                            return response[loc].emailNotExist && response[loc].emailNotExist.length;
                        })) {

                            showConfirmMissingEmails(response, savedData).then(function (result) {
                                if (result.proceed) {
                                    applySettings();

                                    // For selected missing emails, replicate settings from ANY location where it exists
                                    for (var i = 0; i < result.selected.length; i++) {
                                        var sel = result.selected[i];

                                        if (!savedData[sel.loc]) savedData[sel.loc] = [];

                                        // already exists in target?
                                        var alreadyAny = savedData[sel.loc].some(x => x.email === sel.email);
                                        if (alreadyAny) continue;

                                        // Find ALL reference rows across savedData for this email
                                        var refs = [];
                                        for (var sLoc in savedData) {
                                            if (!savedData.hasOwnProperty(sLoc)) continue;
                                            (savedData[sLoc] || []).forEach(function (r) {
                                                if (r.email === sel.email) refs.push(r);
                                            });
                                        }

                                        if (refs.length) {
                                            refs.forEach(function (ref) {
                                                var clone = deepClone(ref);
                                                clone.rowKey = makeRowKey(); // ✅ ensure unique row
                                                clone.locationId = sel.loc;
                                                savedData[sel.loc].push(clone);
                                            });
                                        } else {
                                            // fallback empty
                                            savedData[sel.loc].push({
                                                rowKey: makeRowKey(),
                                                personId: null,
                                                email: sel.email,
                                                reportType: [],
                                                frequency: [],
                                                shift: false,
                                                incident: false,
                                                patrol: false,
                                                checklists: [],
                                                locationId: sel.loc
                                            });
                                        }
                                    }

                                    console.log("✅ Updated savedData with replicated settings:", savedData);
                                }
                            });

                        } else {
                            applySettings();
                        }

                    })
                    .catch(err => {
                        console.error("❌ Error:", err);
                    });

                locationPopup.style.display = "none";
            });
        }
    }

    // update header checkbox checked / indeterminate state
    function updateHeaderCheckboxState(className, headerId) {
        const $inputs = $('#notifTable').find('input.' + className);
        const total = $inputs.length;
        const checked = $inputs.filter(':checked').length;
        const $header = $('#' + headerId);

        if (total === 0) $header.prop('checked', false).prop('indeterminate', false);
        else if (checked === 0) $header.prop('checked', false).prop('indeterminate', false);
        else if (checked === total) $header.prop('checked', true).prop('indeterminate', false);
        else $header.prop('checked', false).prop('indeterminate', true);
    }

    // Reusable modal popup
    function showPopup({ title = "Message", message = "", buttons = [] }) {
        const oldPopup = document.getElementById("customPopup");
        if (oldPopup) oldPopup.remove();

        const overlay = document.createElement("div");
        overlay.id = "customPopup";
        overlay.style.position = "fixed";
        overlay.style.top = "0";
        overlay.style.left = "0";
        overlay.style.width = "100%";
        overlay.style.height = "100%";
        overlay.style.background = "rgba(0,0,0,0.5)";
        overlay.style.display = "flex";
        overlay.style.justifyContent = "center";
        overlay.style.alignItems = "center";
        overlay.style.zIndex = "9999";

        const box = document.createElement("div");
        box.style.background = "#fff";
        box.style.padding = "20px";
        box.style.borderRadius = "10px";
        box.style.maxWidth = "500px";
        box.style.width = "90%";
        box.style.boxShadow = "0 4px 10px rgba(0,0,0,0.3)";
        box.style.textAlign = "center";
        box.style.fontFamily = "Arial, sans-serif";

        const h2 = document.createElement("h2");
        h2.innerText = title;
        h2.style.marginTop = "0";
        h2.style.color = "#020267";
        box.appendChild(h2);

        const p = document.createElement("p");
        p.innerText = message;
        p.style.margin = "15px 0";
        box.appendChild(p);

        const btnContainer = document.createElement("div");
        btnContainer.style.display = "flex";
        btnContainer.style.justifyContent = "center";
        btnContainer.style.gap = "10px";
        btnContainer.style.marginTop = "20px";

        buttons.forEach(btn => {
            const b = document.createElement("button");
            b.innerText = btn.text;
            b.style.padding = "8px 15px";
            b.style.border = "none";
            b.style.borderRadius = "5px";
            b.style.cursor = "pointer";
            b.style.color = "#fff";
            b.style.background = btn.color || "#020267";
            b.onclick = () => {
                overlay.remove();
                if (btn.onClick) btn.onClick();
            };
            btnContainer.appendChild(b);
        });

        box.appendChild(btnContainer);
        overlay.appendChild(box);
        document.body.appendChild(overlay);
    }

    function showMessagePopup({ type = "info", message = "", title = "Message", autoClose = true, duration = 2500 }) {
        const oldPopup = document.getElementById("customPopup");
        if (oldPopup) oldPopup.remove();

        const config = {
            success: { color: "#28a745", icon: "✔️" },
            error: { color: "#dc3545", icon: "❌" },
            warning: { color: "#ffc107", icon: "⚠️" },
            info: { color: "#007bff", icon: "ℹ️" }
        };
        const { color, icon } = config[type] || config.info;

        const overlay = document.createElement("div");
        overlay.id = "customPopup";
        overlay.style.position = "fixed";
        overlay.style.top = "0";
        overlay.style.left = "0";
        overlay.style.width = "100%";
        overlay.style.height = "100%";
        overlay.style.background = "rgba(0,0,0,0.3)";
        overlay.style.display = "flex";
        overlay.style.justifyContent = "center";
        overlay.style.alignItems = "center";
        overlay.style.zIndex = "9999";
        overlay.style.opacity = "0";
        overlay.style.transition = "opacity 0.3s ease";

        const box = document.createElement("div");
        box.style.background = "#fff";
        box.style.padding = "20px 30px";
        box.style.borderRadius = "10px";
        box.style.maxWidth = "400px";
        box.style.width = "90%";
        box.style.boxShadow = "0 4px 12px rgba(0,0,0,0.3)";
        box.style.textAlign = "center";
        box.style.fontFamily = "Arial, sans-serif";
        box.style.position = "relative";
        box.style.transform = "scale(0.9)";
        box.style.transition = "transform 0.3s ease";

        const iconEl = document.createElement("div");
        iconEl.innerHTML = icon;
        iconEl.style.fontSize = "40px";
        iconEl.style.color = color;
        iconEl.style.marginBottom = "10px";
        box.appendChild(iconEl);

        const h2 = document.createElement("h2");
        h2.innerText = title;
        h2.style.marginTop = "0";
        h2.style.color = color;
        box.appendChild(h2);

        const p = document.createElement("p");
        p.innerText = message;
        p.style.margin = "10px 0";
        p.style.fontSize = "16px";
        p.style.color = "#333";
        box.appendChild(p);

        const closeBtn = document.createElement("button");
        closeBtn.innerText = "OK";
        closeBtn.style.padding = "8px 18px";
        closeBtn.style.border = "none";
        closeBtn.style.borderRadius = "5px";
        closeBtn.style.cursor = "pointer";
        closeBtn.style.background = color;
        closeBtn.style.color = "#fff";
        closeBtn.style.marginTop = "15px";
        closeBtn.onclick = () => fadeOut();
        box.appendChild(closeBtn);

        overlay.appendChild(box);
        document.body.appendChild(overlay);

        requestAnimationFrame(() => {
            overlay.style.opacity = "1";
            box.style.transform = "scale(1)";
        });

        function fadeOut() {
            overlay.style.opacity = "0";
            box.style.transform = "scale(0.9)";
            setTimeout(() => overlay.remove(), 300);
        }

        if (autoClose) setTimeout(() => fadeOut(), duration);
    }

    function showConfirmMissingEmails(missingEmailsByLocation, savedDataLocal, title) {
        return new Promise(function (resolve) {
            if (!title) title = "Missing Emails";

            var oldPopup = document.getElementById("customPopup");
            if (oldPopup) oldPopup.parentNode.removeChild(oldPopup);

            var overlay = document.createElement("div");
            overlay.id = "customPopup";
            overlay.style.position = "fixed";
            overlay.style.top = "0";
            overlay.style.left = "0";
            overlay.style.width = "100%";
            overlay.style.height = "100%";
            overlay.style.background = "rgba(0,0,0,0.5)";
            overlay.style.display = "flex";
            overlay.style.justifyContent = "center";
            overlay.style.alignItems = "center";
            overlay.style.zIndex = "9999";

            var box = document.createElement("div");
            box.style.background = "#fff";
            box.style.padding = "20px";
            box.style.borderRadius = "10px";
            box.style.maxWidth = "700px";
            box.style.width = "90%";
            box.style.maxHeight = "80vh";
            box.style.overflowY = "auto";
            box.style.fontFamily = "Arial, sans-serif";

            var h2 = document.createElement("h2");
            h2.innerHTML = title;
            h2.style.marginTop = "0";
            h2.style.color = "#020267";
            box.appendChild(h2);

            var tableHtml = '<table style="width:100%; border-collapse: collapse; margin-top:15px;">' +
                '<thead>' +
                '<tr style="background:#f2f2f2;">' +
                '<th style="padding:8px; border:1px solid #ccc;">Location</th>' +
                '<th style="padding:8px; border:1px solid #ccc;">Email</th>' +
                '<th style="padding:8px; border:1px solid #ccc;">Add?</th>' +
                '</tr>' +
                '</thead><tbody>';

            var hasRows = false;

            for (var loc in missingEmailsByLocation) {
                if (missingEmailsByLocation.hasOwnProperty(loc)) {
                    var data = missingEmailsByLocation[loc];
                    var option = document.querySelector('#notifLocationSelect option[value="' + loc + '"]');
                    var locName = option ? option.text : loc;

                    if (data.emailNotExist && data.emailNotExist.length) {
                        for (var i = 0; i < data.emailNotExist.length; i++) {
                            var email = data.emailNotExist[i];

                            // Only include if this email exists in savedData somewhere with settings
                            var keep = false;
                            for (var sLoc in savedDataLocal) {
                                if (savedDataLocal.hasOwnProperty(sLoc)) {
                                    for (var j = 0; j < (savedDataLocal[sLoc] || []).length; j++) {
                                        if (savedDataLocal[sLoc][j].email === email) {
                                            var item = savedDataLocal[sLoc][j];
                                            if ((item.reportType && item.reportType.length) ||
                                                (item.frequency && item.frequency.length) ||
                                                item.shift || item.incident || item.patrol) {
                                                keep = true;
                                                break;
                                            }
                                        }
                                    }
                                }
                                if (keep) break;
                            }

                            if (keep) {
                                hasRows = true;
                                tableHtml += '<tr>' +
                                    '<td style="padding:6px; border:1px solid #ccc;">' + locName + ' (' + loc + ')</td>' +
                                    '<td style="padding:6px; border:1px solid #ccc;">' + email + '</td>' +
                                    '<td style="padding:6px; border:1px solid #ccc; text-align:center;">' +
                                    '<input type="checkbox" data-loc="' + loc + '" data-email="' + email + '">' +
                                    '</td>' +
                                    '</tr>';
                            }
                        }
                    }
                }
            }

            tableHtml += '</tbody></table>';

            if (!hasRows) {
                resolve({ proceed: false, selected: [] });
                return;
            }

            var tableContainer = document.createElement("div");
            tableContainer.innerHTML = tableHtml;
            box.appendChild(tableContainer);

            var btnContainer = document.createElement("div");
            btnContainer.style.display = "flex";
            btnContainer.style.justifyContent = "center";
            btnContainer.style.gap = "10px";
            btnContainer.style.marginTop = "20px";

            var cancelBtn = document.createElement("button");
            cancelBtn.innerHTML = "Cancel";
            cancelBtn.style.padding = "8px 15px";
            cancelBtn.style.border = "none";
            cancelBtn.style.borderRadius = "5px";
            cancelBtn.style.cursor = "pointer";
            cancelBtn.style.background = "gray";
            cancelBtn.style.color = "#fff";
            cancelBtn.onclick = function () {
                overlay.parentNode.removeChild(overlay);
                resolve({ proceed: false, selected: [] });
            };

            var okBtn = document.createElement("button");
            okBtn.innerHTML = "OK";
            okBtn.style.padding = "8px 15px";
            okBtn.style.border = "none";
            okBtn.style.borderRadius = "5px";
            okBtn.style.cursor = "pointer";
            okBtn.style.background = "#54834D";
            okBtn.style.color = "#fff";
            okBtn.onclick = function () {
                var checkboxes = tableContainer.querySelectorAll("input[type=checkbox]:checked");
                var selected = [];
                for (var j = 0; j < checkboxes.length; j++) {
                    selected.push({
                        loc: checkboxes[j].getAttribute("data-loc"),
                        email: checkboxes[j].getAttribute("data-email")
                    });
                }
                overlay.parentNode.removeChild(overlay);
                resolve({ proceed: true, selected: selected });
            };

            btnContainer.appendChild(cancelBtn);
            btnContainer.appendChild(okBtn);
            box.appendChild(btnContainer);
            overlay.appendChild(box);
            document.body.appendChild(overlay);
        });
    }

    function showAlert(message, title = "Alert") {
        return new Promise(resolve => {
            showPopup({
                title,
                message,
                buttons: [{ text: "OK", color: "#54834D", onClick: () => resolve(true) }]
            });
        });
    }

    // ============================================================
    // ✅ DataTable (UPDATED: rowKey column + rowKey-based merge)
    // ============================================================
    function populateDataTable(locationId) {
        if (table) {
            table.clear().draw();
            table.ajax.url(url + '/public/emails/' + locationId).load();
            return;
        }

        table = $('#notifTable').DataTable({
            ajax: {
                url: url + '/public/emails/' + (locationId || 0),
                dataSrc: function (json) {
                    const currentId = $('#notifLocationSelect').val();
                    var rows = Array.isArray(json) ? json : (json.content || []);
                    var savedRows = savedData[currentId] || [];

                    // Ensure every incoming row has a rowKey
                    rows.forEach(row => {
                        row.rowKey = ensureRowKey(row);
                    });

                    // Merge saved settings into server rows by rowKey
                    rows.forEach(row => {
                        const savedRow = savedRows.find(r => r.rowKey === row.rowKey);
                        if (savedRow) {
                            row.reportType = savedRow.reportType || [];
                            row.frequency = savedRow.frequency || [];
                            row.shift = !!savedRow.shift;
                            row.incident = !!savedRow.incident;
                            row.patrol = !!savedRow.patrol;
                            row.checklists = Array.isArray(savedRow.checklists) ? savedRow.checklists : [];
                        } else {
                            row.reportType = [];
                            row.frequency = [];
                            row.shift = false;
                            row.incident = false;
                            row.patrol = false;
                            row.checklists = [];
                        }
                    });

                    // Add saved rows that are not in server rows (typically UI-added rows)
                    savedRows.forEach(savedRow => {
                        if (!rows.some(r => r.rowKey === savedRow.rowKey)) {
                            rows.push(deepClone(savedRow));
                        }
                    });

                    return rows;
                }
            },

            pageLength: 10,
            lengthMenu: [
                [10, 25, 50, 100, -1],
                [10, 25, 50, 100, "All"]
            ],

            columns: [
                { data: 'rowKey', visible: false },    // ✅ NEW hidden identity column
                { data: 'personId', visible: false },
                { data: 'email', title: 'User' },

                {
                    data: 'reportType',
                    title: 'Report Type',
                    render: function (reportType, type, row) {
                        const currentId = $('#notifLocationSelect').val();
                        const savedRow = (savedData[currentId] || []).find(r => r.rowKey === row.rowKey);
                        const selected = savedRow ? (savedRow.reportType || []) : [];

                        const reportLabels = { summary: "Summary", fullReport: "Full Report" };
                        const selectedLabels = selected.map(v => reportLabels[v] || v);

                        let html = '<div class="notif-multiselect report-select" data-rowkey="' + row.rowKey + '">';
                        html += `<span class="pill-text">${selectedLabels.length ? selectedLabels.join(', ') : 'Select Report Type...'}</span>`;
                        html += '<div class="options">';
                        Object.keys(reportLabels).forEach(v => {
                            const isSelected = selected.includes(v);
                            html += `<div class="option${isSelected ? ' selected' : ''}" data-value="${v}">${reportLabels[v]}</div>`;
                        });
                        html += '</div></div>';
                        return html;
                    }
                },

                {
                    data: 'frequency',
                    title: 'Frequency',
                    render: function (frequency, type, row) {
                        const currentId = $('#notifLocationSelect').val();
                        const savedRow = (savedData[currentId] || []).find(r => r.rowKey === row.rowKey);
                        const selected = savedRow ? (savedRow.frequency || []) : [];

                        const freqLabels = {
                            daily: "Daily",
                            weekly: "Weekly",
                            biweekly: "Bi-Weekly",
                            monthly: "Monthly",
                            quarterly: "Quarterly",
                            yearly: "Yearly"
                        };

                        const selectedLabels = selected.map(v => freqLabels[v] || v);

                        let html = '<div class="notif-multiselect frequency-select" data-rowkey="' + row.rowKey + '">';
                        html += `<span class="pill-text">${selectedLabels.length ? selectedLabels.join(', ') : 'Select Frequency...'}</span>`;
                        html += '<div class="options">';
                        Object.keys(freqLabels).forEach(v => {
                            const isSelected = selected.includes(v);
                            html += `<div class="option${isSelected ? ' selected' : ''}" data-value="${v}">${freqLabels[v]}</div>`;
                        });
                        html += '</div></div>';
                        return html;
                    }
                },

                {
                    data: null,
                    title: "Checklists",
                    render: function (data, type, row) {
                        const currentId = $('#notifLocationSelect').val();
                        const savedRow = (savedData[currentId] || []).find(r => r.rowKey === row.rowKey);
                        var selectedCount = (savedRow && savedRow.checklists && savedRow.checklists.length) ? savedRow.checklists.length : 0;

                        return `
              <div class="sb-prelated cl-field"
                   data-rowkey="${row.rowKey}"
                   data-email="${row.email}"
                   data-source="table"
                   data-toggle="imodal"
                   data-target="#checklistsModal">
                <input class="form-input input success"
                       name="checklists-text"
                       value="${selectedCount > 0 ? '(' + selectedCount + ') Selected' : 'Select Checklists'}"
                       type="text" readonly="true">
                <input name="checklists" class="sb-submit-field" type="hidden">
              </div>
            `;
                    }
                },

                {
                    data: 'shift',
                    title: `<span class="checkbox-header" title="Shift Report">
            <input type="checkbox" id="selectAllShift">
            <label for="selectAllShift" title="Daily Shift Report">DSR</label>
          </span>`,
                    render: function (shift, type, row) {
                        const currentId = $('#notifLocationSelect').val();
                        const savedRow = (savedData[currentId] || []).find(r => r.rowKey === row.rowKey);
                        const checked = savedRow ? !!savedRow.shift : false;
                        return `<input type="checkbox" class="shift" ${checked ? 'checked' : ''}>`;
                    }
                },

                {
                    data: 'incident',
                    title: `<span class="checkbox-header">
            <input type="checkbox" id="selectAllIncident">
            <label for="selectAllIncident" title="Incident Report">IR</label>
          </span>`,
                    render: function (incident, type, row) {
                        const currentId = $('#notifLocationSelect').val();
                        const savedRow = (savedData[currentId] || []).find(r => r.rowKey === row.rowKey);
                        const checked = savedRow ? !!savedRow.incident : false;
                        return `<input type="checkbox" class="incident" ${checked ? 'checked' : ''}>`;
                    }
                },

                {
                    data: 'patrol',
                    title: `<span class="checkbox-header">
            <input type="checkbox" id="selectAllPatrol">
            <label for="selectAllPatrol" title="Checklists, Compliance, Patrols">Checks</label>
          </span>`,
                    render: function (patrol, type, row) {
                        const currentId = $('#notifLocationSelect').val();
                        const savedRow = (savedData[currentId] || []).find(r => r.rowKey === row.rowKey);
                        const checked = savedRow ? !!savedRow.patrol : false;
                        return `<input type="checkbox" class="patrol" ${checked ? 'checked' : ''}>`;
                    }
                },

                {
                    data: null,
                    title: 'Delete',
                    orderable: false,
                    render: function (data, type, row) {
                        // allow delete for UI-added rows (personId null)
                        if (row.personId === null) {
                            return '<button class="remove-table-email" style="color:#0d6efd;font-weight:bold;border:none;background:none;cursor:pointer;">×</button>';
                        }
                        return '';
                    }
                }
            ],

            columnDefs: [
                {
                    // disable ordering on these column indexes (NOTE: shifted by +1 because rowKey hidden)
                    targets: [0, 1, 3, 4, 5, 6, 7, 8],
                    orderable: false
                }
            ],

            drawCallback: function () {
                updateHeaderCheckboxState('shift', 'selectAllShift');
                updateHeaderCheckboxState('incident', 'selectAllIncident');
                updateHeaderCheckboxState('patrol', 'selectAllPatrol');
            },

            initComplete: function () {
                loadFunctions();
            }
        });

        // Remove button for added rows (also remove from savedData by rowKey)
        $('#notifTable tbody').off('click', '.remove-table-email').on('click', '.remove-table-email', function () {
            const $tr = $(this).closest('tr');
            const rowData = table.row($tr).data() || {};
            const locationId = $('#notifLocationSelect').val();

            if (rowData.rowKey) removeSavedRow(locationId, rowData.rowKey);

            table.row($tr).remove().draw(false);
        });
    }

    function loadChecklistFromAPI(locationId, locationName) {
        return fetch("/action/get-checklists?locationId=" + locationId)
            .then(res => res.json())
            .then(data => {
                SAMPLE_CL = data.map(item => ({
                    id: item.genDataId,
                    name: item.field2,
                    group: locationName
                }));
            })
            .catch(err => {
                console.error("Checklists load failed", err);
            });
    }

    function initTreeMultiSelect(config) {
        const modal = document.getElementById(config.modalId);
        const treeList = document.getElementById("treeList");
        const selectedBox = document.getElementById("treeSelected");
        const searchBox = document.getElementById("treeSearch");

        let selectedItems = new Set(config.preselected || []);
        window.currentTreeSelected = selectedItems;

        function renderTree() {
            treeList.innerHTML = "";

            const groupMap = {};
            config.data.forEach(item => {
                if (!groupMap[item.group]) groupMap[item.group] = [];
                groupMap[item.group].push(item);
            });

            Object.keys(groupMap).forEach(groupName => {
                const groupItems = groupMap[groupName];

                const groupDiv = document.createElement("div");
                groupDiv.className = "tree-group";

                const groupChk = document.createElement("input");
                groupChk.type = "checkbox";

                const groupLabel = document.createElement("span");
                groupLabel.textContent = groupName;

                groupDiv.appendChild(groupChk);
                groupDiv.appendChild(groupLabel);

                const itemsDiv = document.createElement("div");
                itemsDiv.className = "tree-items";

                groupItems.forEach(item => {
                    const itemDiv = document.createElement("div");
                    itemDiv.className = "tree-item";

                    const chk = document.createElement("input");
                    chk.type = "checkbox";
                    chk.value = item.id;

                    chk.checked = selectedItems.has(item.id);

                    chk.addEventListener("change", () => {
                        if (chk.checked) selectedItems.add(item.id);
                        else selectedItems.delete(item.id);
                        renderSelected();
                        updateGroupCheckbox(groupChk, groupItems);
                        config.onChange([...selectedItems]);
                    });

                    const lbl = document.createElement("span");
                    lbl.textContent = item.name;

                    itemDiv.appendChild(chk);
                    itemDiv.appendChild(lbl);
                    itemsDiv.appendChild(itemDiv);
                });

                groupChk.addEventListener("change", () => {
                    groupItems.forEach(item => {
                        if (groupChk.checked) selectedItems.add(item.id);
                        else selectedItems.delete(item.id);
                    });
                    renderTree();
                    renderSelected();
                    config.onChange([...selectedItems]);
                });

                treeList.appendChild(groupDiv);
                treeList.appendChild(itemsDiv);

                updateGroupCheckbox(groupChk, groupItems);
            });
        }

        function updateGroupCheckbox(groupChk, items) {
            const total = items.length;
            let checkedCount = 0;

            items.forEach(item => {
                if (selectedItems.has(item.id)) checkedCount++;
            });

            if (checkedCount === 0) {
                groupChk.indeterminate = false;
                groupChk.checked = false;
            } else if (checkedCount === total) {
                groupChk.indeterminate = false;
                groupChk.checked = true;
            } else {
                groupChk.checked = false;
                groupChk.indeterminate = true;
            }
        }

        function renderSelected() {
            selectedBox.innerHTML = "";

            config.data.forEach(item => {
                if (selectedItems.has(item.id)) {
                    let pill = document.createElement("div");
                    pill.className = "selected-pill";

                    let text = document.createElement("span");
                    text.textContent = item.name;

                    let remove = document.createElement("span");
                    remove.className = "remove";
                    remove.textContent = "✕";
                    remove.addEventListener("click", () => {
                        selectedItems.delete(item.id);
                        renderTree();
                        renderSelected();
                        config.onChange([...selectedItems]);
                    });

                    pill.appendChild(text);
                    pill.appendChild(remove);
                    selectedBox.appendChild(pill);
                }
            });
        }

        searchBox.addEventListener("input", () => {
            const term = searchBox.value.toLowerCase();
            document.querySelectorAll(".tree-item").forEach(item => {
                const text = item.innerText.toLowerCase();
                item.style.display = text.includes(term) ? "" : "none";
            });
        });

        document.getElementById("selectAllBtn").addEventListener("click", () => {
            config.data.forEach(item => selectedItems.add(item.id));
            renderTree();
            renderSelected();
            config.onChange([...selectedItems]);
        });

        document.getElementById("unselectAllBtn").addEventListener("click", () => {
            selectedItems.clear();
            renderTree();
            renderSelected();
            config.onChange([...selectedItems]);
        });

        renderTree();
        renderSelected();
    }

    function loadFunctions() {
        // Make entire cell clickable for checkboxes
        $('#notifTable tbody').on('click', 'td', function (e) {
            const $cell = $(this);

            if ($(e.target).is('input') || $(e.target).is('button')) return;

            const $checkbox = $cell.find('input[type="checkbox"]');
            if ($checkbox.length) {
                $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
            }

            const $button = $cell.find('.remove-table-email');
            if ($button.length) {
                $button.trigger('click');
            }
        });

        $(document).on('click', '.remove-table-email', function () {
            const $tr = $(this).closest('tr');
            const rowData = table.row($tr).data() || {};
            const locationId = $('#notifLocationSelect').val();

            if (rowData.rowKey) removeSavedRow(locationId, rowData.rowKey);

            const row = table.row($tr);
            row.remove().draw(false);
        });
    }

    function getLocations() {
        const personId = $('#userId').val();

        $.ajax({
            url: `${geofenceUrl}/public/get-locations`,
            method: "get",
            data: { personId: personId },
            dataType: 'json',
            success: function (response) {
                let content = response.content || [];
                let options = "";
                content.forEach(loc => {
                    options += `<option value="${loc.id}">${loc.name}</option>`;
                });

                $('#notifLocationSelect').html(options).select2({
                    placeholder: "Select a location",
                    allowClear: true
                });

                populateSavedData().then(() => {
                    const locationId = $('#notifLocationSelect').val();

                    loadChecklistFromAPI(locationId, $('#notifLocationSelect option:selected').text())
                        .then(() => populateDataTable(locationId));
                });
            },
            error: () => {
                console.warn("no data available!");
            }
        });
    }

    function populateSavedData() {
        const personId = $('#userId').val();

        return $.ajax({
            url: '/action/report-settings-action',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ personId: personId, action: 'get' }),
            success: function (response) {
                try {
                    savedData = typeof response === 'string' ? JSON.parse(response) : response;
                } catch (e) {
                    console.error("Failed to parse saved data:", e);
                    savedData = {};
                }

                // Ensure each saved row has rowKey (backward compat)
                Object.keys(savedData || {}).forEach(locId => {
                    savedData[locId] = (savedData[locId] || []).map(r => {
                        // ✅ If this row is a real user (personId exists), make it stable and match server
                        if (r.personId != null) {
                            r.rowKey = 'pid_' + r.personId;
                        } else if (!r.rowKey) {
                            // UI-added row (no personId) must remain unique
                            r.rowKey = makeRowKey();
                        }

                        if (!Array.isArray(r.checklists)) r.checklists = [];
                        if (!Array.isArray(r.reportType)) r.reportType = [];
                        if (!Array.isArray(r.frequency)) r.frequency = [];
                        return r;
                    });
                });

                populateDataTable($('#notifLocationSelect').val());
            },
            error: function (xhr) {
                console.error("Failed to fetch saved settings:", xhr.status, xhr.responseText);
                savedData = {};
                populateDataTable($('#notifLocationSelect').val());
            }
        });
    }

    function updateSavedData() {
        const personId = $('#userId').val();

        $.ajax({
            url: '/action/report-settings-action',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ personId: personId, action: 'update', value: savedData }),
            success: function (response) {
                console.log("Update successful:", response);
                showMessagePopup({
                    type: "success",
                    title: "Success!",
                    message: "Your data has been saved successfully."
                });
            },
            error: function (xhr) {
                console.error("Failed to update saved data:", xhr.status, xhr.responseText);
            }
        });
    }

    function actionLocationChange({ currentTarget }) {
        const locationId = $(currentTarget).val();
        const locationName = $('#notifLocationSelect option:selected').text();
        if (!locationId) return;

        // Clear previous selections for generate-report
        $('.cl-field[data-source="generate-report"]')
            .attr("data-items", "")
            .find('input[name="checklists-text-generate"]')
            .val("Select Checklists");

        window.currentTreeSelected = new Set();

        loadChecklistFromAPI(locationId, locationName)
            .then(() => {
                if (table) {
                    table.clear().draw();
                    table.ajax.url(`${url}/public/emails/${locationId}`).load();
                }
            });
    }

    // ============================================================
    // ✅ Submit validation (UPDATED: works with duplicate emails)
    // ============================================================
    function nofitSubmit() {
        $('#notifTable tbody tr').removeClass('invalid-row');

        var foundAnyConfigured = false;
        var errors = [];

        Object.keys(savedData).forEach(locationId => {
            (savedData[locationId] || []).forEach((row, index) => {
                var rowErrors = [];

                var reportType = row.reportType || [];
                var frequency = row.frequency || [];
                var shift = !!row.shift;
                var incident = !!row.incident;
                var patrol = !!row.patrol;

                var anySelected = (reportType.length > 0) || (frequency.length > 0) || shift || incident || patrol;

                if (anySelected) {
                    foundAnyConfigured = true;

                    if (reportType.length === 0) rowErrors.push('select Report Type');
                    if (frequency.length === 0) rowErrors.push('select Frequency');
                    if (!(shift || incident || patrol)) rowErrors.push('select at least one Report (Shift / Incident / Patrol)');

                    if (rowErrors.length > 0) {
                        var label = row.email || 'Unknown user';
                        const opt = document.querySelector(`#notifLocationSelect option[value="${locationId}"]`);
                        const locName = opt ? opt.text : locationId;

                        // include rowKey so duplicates are distinguishable in message
                        errors.push(`[${locName}] ${label} (${row.rowKey}): ${rowErrors.join('; ')}`);

                        // highlight matching visible row by rowKey
                        $('#notifTable tbody tr').each(function () {
                            var trData = table.row(this).data();
                            if (trData && trData.rowKey === row.rowKey) {
                                $(this).addClass('invalid-row');
                            }
                        });
                    }
                }
            });
        });

        if (!foundAnyConfigured) {
            showAlert('Please configure at least one user (choose report type, frequency and at least one report) before submitting.');
            return;
        }

        if (errors.length > 0) {
            var msg = 'Please fix the following rows before submitting:\n\n' + errors.join('\n');
            showAlert(msg);
            return;
        }

        updateSavedData();
        console.log('Final savedData:', savedData);
    }

    function toggleRemoveButtons() {
        const rows = document.querySelectorAll("#emailFields .email-row");
        rows.forEach(row => {
            const removeBtn = row.querySelector(".remove-btn");
            if (removeBtn) {
                if (rows.length === 1) removeBtn.style.display = "none";
                else removeBtn.style.display = "inline-block";
            }
        });
    }

    // ============================================================
    // ✅ Add Email Popup (UPDATED: duplicates allowed + rowKey generated)
    // ============================================================
    function loadEmailPopup() {
        $('#addEmailBtn').on('click', function () {
            $('#addEmailPopup').fadeIn().css('display', 'flex');
            toggleRemoveButtons();
        });

        $('#cancelPopupBtn').on('click', function () {
            $('#addEmailPopup').fadeOut();
            emails = [];
            $('#emailChips').empty();
            $('#emailInput').val('');
        });

        $('#emailInput').on('keypress', function (e) {
            if (e.key === 'Enter' || e.key === ',') {
                e.preventDefault();
                let email = $(this).val().trim().replace(/,$/, '');
                if (validateEmail(email)) {
                    emails.push(email);
                    $('#emailChips').append(
                        `<div class="chip">${email}<span class="remove">×</span></div>`
                    );
                } else if (email) {
                    showAlert('Invalid email!');
                }
                $(this).val('');
            }
        });

        $(document).on('click', '.chip .remove', function () {
            let email = $(this).parent().text().slice(0, -1);
            emails = emails.filter(e => e !== email);
            $(this).parent().remove();
        });

        // Save emails -> add to table (duplicates allowed)
        document.getElementById("saveEmailBtn").addEventListener("click", function () {
            const inputs = document.querySelectorAll(".email-input");
            const newEmails = [];
            let valid = true;

            inputs.forEach(input => {
                const email = input.value.trim();
                if (email !== "") {
                    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                        newEmails.push(email);
                    } else {
                        valid = false;
                        input.style.border = "1px solid red";
                    }
                }
            });

            if (!valid || newEmails.length === 0) {
                if (newEmails.length === 0) showAlert('Invalid email!');
                return;
            }

            const locationId = $('#notifLocationSelect').val();

            newEmails.forEach(email => {
                const rk = makeRowKey();

                const rowObj = {
                    rowKey: rk,
                    personId: null,
                    email: email,
                    reportType: [],
                    frequency: [],
                    shift: false,
                    incident: false,
                    patrol: false,
                    checklists: []
                };

                // Add to table
                table.row.add(rowObj).draw(false);

                // Add blank setting to savedData (so it’s independently configurable)
                upsertSavedRow(locationId, deepClone(rowObj));
            });

            document.getElementById("addEmailPopup").style.display = "none";
            document.querySelectorAll(".email-input").forEach(i => i.value = "");
            document.getElementById("emailFields").innerHTML = `
        <div class="email-row">
          <input type="email" class="email-input" placeholder="Enter email" />
          <button type="button" class="remove-btn">✖</button>
        </div>
      `;
        });

        function validateEmail(email) {
            let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        }

        document.getElementById("addMoreBtn").addEventListener("click", function () {
            const emailFields = document.getElementById("emailFields");
            const row = document.createElement("div");
            row.className = "email-row";
            row.innerHTML = `
        <input type="email" class="email-input" placeholder="Enter email" />
        <button type="button" class="remove-btn">✖</button>
      `;
            emailFields.appendChild(row);
            toggleRemoveButtons();
        });

        document.getElementById("emailFields").addEventListener("click", function (e) {
            if (e.target.classList.contains("remove-btn")) {
                e.target.parentElement.remove();
                toggleRemoveButtons();
            }
        });
    }

    function pillTextForReport() {
        const $reportFor = $('#reportFor');
        const $pillText = $reportFor.find('.pill-text');
        const $options = $reportFor.find('.option');

        let selectedValues = [];

        $reportFor.on('click', function (e) {
            e.stopPropagation();
            $reportFor.toggleClass('open');
            $reportFor.find('.options').toggle();
        });

        $options.on('click', function (e) {
            e.stopPropagation();
            const $opt = $(this);
            const value = $opt.data('value');

            if (selectedValues.includes(value)) {
                selectedValues = selectedValues.filter(v => v !== value);
                $opt.removeClass('selected');
            } else {
                selectedValues.push(value);
                $opt.addClass('selected');
            }

            const selectedLabels = $options.filter('.selected').map(function () {
                return $(this).text();
            }).get();

            $pillText.text(selectedLabels.length ? selectedLabels.join(', ') : 'Select Report Type...');
        });

        $(document).on('click', function () {
            $reportFor.removeClass('open');
            $reportFor.find('.options').hide();
        });
    }

    function getFileName(report, frequency, reportType, locationName) {
        var prefixMap = { 'shift': 'DSR', 'incident': 'IR', 'patrol': 'Patrol' };
        var prefix = prefixMap[report.toLowerCase()] || 'report';

        var startDate, endDate;
        var today = new Date();

        switch (frequency.toLowerCase()) {
            case 'daily':
                var yesterday = new Date();
                yesterday.setDate(today.getDate() - 1);
                startDate = endDate = yesterday;
                break;
            case 'weekly':
                var day = today.getDay();
                var diffToLastMonday = day + 6;
                startDate = new Date(today);
                startDate.setDate(today.getDate() - diffToLastMonday);
                endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + 6);
                break;
            case 'biweekly':
                var day2 = today.getDay();
                var diffToLastMonday2 = day2 + 13;
                startDate = new Date(today);
                startDate.setDate(today.getDate() - diffToLastMonday2);
                endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + 13);
                break;
            case 'monthly':
                startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                endDate = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case 'quarterly':
                var quarter = Math.floor(today.getMonth() / 3);
                var startMonth = (quarter - 1) * 3;
                if (startMonth < 0) startMonth = 9;
                var year = today.getFullYear();
                if (quarter === 0) year -= 1;
                startDate = new Date(year, startMonth, 1);
                endDate = new Date(year, startMonth + 3, 0);
                break;
            case 'yearly':
                startDate = new Date(today.getFullYear() - 1, 0, 1);
                endDate = new Date(today.getFullYear() - 1, 11, 31);
                break;
            default:
                startDate = endDate = today;
        }

        function formatDate(d) {
            var dd = ('0' + d.getDate()).slice(-2);
            var mm = ('0' + (d.getMonth() + 1)).slice(-2);
            var yyyy = d.getFullYear();
            return dd + '-' + mm + '-' + yyyy;
        }

        var datePart = formatDate(startDate);
        if (startDate.getTime() !== endDate.getTime()) {
            datePart += '_to_' + formatDate(endDate);
        }

        return locationName + '-' + prefix + '-' + reportType + '-' + datePart + '.pdf';
    }

    $(window).ready(function () {
        init();
    });

})(jQuery);
